// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"d2de2a04","329":"4675728e","453":"17abf6d6","611":"e468cf0d","687":"4574683d","963":"8deb0846"}[chunkId] + ".chunk.js";
};